module.exports = __webpack_public_path__ + "img/getcode-2.286d3991.png";